module.exports = __webpack_public_path__ + "img/clientes.7c21cd65.svg";